import { render, staticRenderFns } from "./HumanSensor.vue?vue&type=template&id=ef9863be&scoped=true&"
import script from "./HumanSensor.vue?vue&type=script&lang=js&"
export * from "./HumanSensor.vue?vue&type=script&lang=js&"
import style0 from "./HumanSensor.vue?vue&type=style&index=0&id=ef9863be&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef9863be",
  null
  
)

export default component.exports